<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);

  const chartData = listData.list;
  const colorList = ['#88D9FF', '#0092FF', '#81EDD2', '#B0FA93', '#63F2FF', '#9999FE'];
  const sum = chartData.reduce((per, cur) => per + cur.value, 0);
  const gap = (1 * sum) / 100;
  const pieData1 = [];
  const pieData2 = [];
  const gapData = {
    name: "",
    value: gap,
    itemStyle: {
      color: "transparent",
    },
  };

  //图标位置显示
  let lefts = ["5%", "50%", "5%", "50%", "5%", "50%"];
  let tops = ["25%", "25%", "15%", "15%", "5%", "5%"];
  let legendData = [];
  let total = 0;
  chartData.forEach((item) => {
    total += item.value;
  });

  for (let i = 0; i < chartData.length; i++) {
    // 第一圈数据
    pieData1.push({
      ...chartData[i],
      itemStyle: {
        borderRadius: 10,
      },
    });
    pieData1.push(gapData);

    // 第二圈数据
    pieData2.push({
      ...chartData[i],
      itemStyle: {
        color: colorList[i],
        opacity: 0.21,
      },
    });
    pieData2.push(gapData);

    //  分散图例
    let bfb = parseInt((chartData[i].value / total) * 100) + "%";
    legendData.push({
      show: true,
      icon: "circle", //'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
      // left: lefts[i],
      left:lefts[i],
      bottom: tops[i],
      // itemWidth: '10px',
      // itemHeight:'10px',
      itemStyle: {
        color: colorList[i],
      },
      formatter:
        `{aa| ` + chartData[i].name + ` }`  +`{value| ` + chartData[i].value +"%"+ `}`,
        // `{aa| ` + chartData[i].name + ` }`  +`{value| ` + chartData[i].value +"亩"+ ` }`+ `{bb| ` + bfb + `}`, // 也可以是个函数return
      // x: "left",
      // + `\n\n`
      textStyle: {
        // color: "#BAFF7F",
        rich: {
          aa: {
            color: "#ffffff",
            fontSize:26
          },
          value: {
            color: colorList[i],
            fontSize:26
          },
          bb: {
            color: colorList[i],
            fontSize:26
          },
        },
      },
      data: [chartData[i].name],
    });
  }

  const option= {
    title: {
      text: listData.name,
      subtext: "",
      x: "39%",
      y: "30%",
      itemGap:15,
      textStyle: {
        color: "#f5f5f6",
        fontSize: 50,
        fontWeight: "normal",
      },
      subtextStyle: {

        color: "#f5f5f6",
        fontSize: 50,
        fontWeight: "bold",
      },
      textAlign:'center'
    },

    // backgroundColor: "#0F141B",
    tooltip: {
      show: true,
      backgroundColor: "rgba(0, 0, 0,.8)",
      textStyle: {
        color: "#fff",
      },
    },
    legend: legendData,
    grid: {
      top: 30,
      right: 20,
      bottom: 10,
      left: 10,
    },
    color: colorList,
    series: [
      {
        name: '',
        type: 'pie',
        roundCap: true,
        radius: ['46%', '50%'],
        center: ['40%', '35%'],
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        data: pieData1
      },
      {
        type: 'pie',
        radius: ['46%', '40%'],
        center: ['40%', '35%'],
        gap: 1.71,
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        silent: true,
        data: pieData2
      },
      {
        type: 'gauge',
        zlevel: 2,
        splitNumber: 90,
        radius: '40%',
        center: ['40%', '35%'],
        startAngle: 90,
        endAngle: -269.9999,
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: true,
          length: 7,
          lineStyle: {
            width: 4,
            color: 'rgb(33,85,130)',
          },
        },
        pointer: {
          show: 0,
        },
        detail: {
          show: 0,
        },
      },
      {
        type: 'pie',
        center: ['40%', '35%'],
        radius: [0, '40.6%'],
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        itemStyle: {
          color: 'rgba(75, 126, 203,.1)'
        },
        silent: true,
        data: [
          {
            value: 100,
            name: ''
          }
        ]
      }
    ],
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
